import * as API from "../api/user";

export const UserTypes = {
  LIST_PROGRAMS_START: "user/LIST_PROGRAMS_START",
  LIST_PROGRAMS_SUCCESS: "user/LIST_PROGRAMS_SUCCESS",
  LIST_PROGRAMS_FAILURE: "user/LIST_PROGRAMS_FAILURE",
  SWITCH_PROGRAM_START: "user/SWITCH_PROGRAM_START",
  SWITCH_PROGRAM_SUCCESS: "user/SWITCH_PROGRAM_SUCCESS",
  SWITCH_PROGRAM_FAILURE: "user/SWITCH_PROGRAM_FAILURE",
  GET_FEED_START: "user/GET_FEED_START",
  GET_FEED_SUCCESS: "user/GET_FEED_SUCCESS",
  GET_FEED_FAILURE: "user/GET_FEED_FAILURE",
  CHANGE_PASSWORD_SUCCESS: "user/CHANGE_PASSWORD_SUCCESS",
  CHANGE_PASSWORD_FAILURE: "user/CHANGE_PASSWORD_FAILURE",
  SIGNUP_START: "user/SIGNUP_START",
  SIGNUP_SUCCESS: "user/SIGNUP_SUCCESS",
  SIGNUP_FAILURE: "user/SIGNUP_FAILURE",
  LOGIN_START: "user/LOGIN_START",
  LOGIN_SUCCESS: "user/LOGIN_SUCCESS",
  LOGIN_FAILURE: "user/LOGIN_FAILURE",
  AUTH_STORE_LOGIN_STATE: "user/AUTH_STORE_LOGIN_STATE",
  AUTH_CLEAR_STORED_LOGIN_STATE: "user/AUTH_CLEAR_STORED_LOGIN_STATE",
  LOGOUT: "user/LOGOUT"
};

export const listProgramsStart = () => ({
  type: UserTypes.LIST_PROGRAMS_START
});

export const listProgramsSuccess = payload => ({
  type: UserTypes.LIST_PROGRAMS_SUCCESS,
  payload
});

export const listProgramsFailure = payload => ({
  type: UserTypes.LIST_PROGRAMS_FAILURE,
  payload
});

export const listPrograms = payload => async dispatch => {
  dispatch(listProgramsStart());

  const response = await API.listPrograms(payload);

  if (response.ok) {
    const body = await response.json();
    dispatch(listProgramsSuccess(body.payload));
  } else {
    dispatch(listProgramsFailure());
  }
};

export const switchProgramStart = () => ({
  type: UserTypes.SWITCH_PROGRAM_START
});

export const switchProgramSuccess = payload => ({
  type: UserTypes.SWITCH_PROGRAM_SUCCESS,
  payload
});

export const switchProgramFailure = payload => ({
  type: UserTypes.SWITCH_PROGRAM_FAILURE,
  payload
});

export const switchProgram = payload => async dispatch => {
  dispatch(switchProgramStart());

  const response = await API.switchProgram(payload);
  const body = await response.json();

  if (response.ok) {
    dispatch(switchProgramSuccess(body.payload));
  } else {
    dispatch(switchProgramFailure(body.payload));
  }
};

export const getFeedStart = () => ({
  type: UserTypes.GET_FEED_START
});

export const getFeedSuccess = payload => ({
  type: UserTypes.GET_FEED_SUCCESS,
  payload
});

export const getFeedFailure = payload => ({
  type: UserTypes.GET_FEED_FAILURE,
  payload
});

export const getFeed = payload => async dispatch => {
  dispatch(getFeedStart());

  const response = await API.getFeed(payload);

  if (response.ok) {
    const body = await response.json();
    dispatch(getFeedSuccess(body.payload));
  } else {
    dispatch(getFeedFailure());
  }
};

export const changePasswordFailure = payload => ({
  type: UserTypes.CHANGE_PASSWORD_FAILURE,
  payload
});

export const changePasswordSucess = payload => ({
  type: UserTypes.CHANGE_PASSWORD_SUCCESS,
  payload
});

export const changePassword = payload => async dispatch => {
  const response = await API.changePassword(payload);
  return {
    success: response.ok
  };
};

export const signUpStart = () => ({
  type: UserTypes.SIGNUP_START
});

export const signUpSuccess = payload => ({
  type: UserTypes.SIGNUP_SUCCESS,
  payload
});

export const signUpFailure = payload => ({
  type: UserTypes.SIGNUP_FAILURE,
  payload
});

export const signUp = payload => async dispatch => {
  dispatch(signUpStart());

  const response = await API.signup(payload);
  const body = await response.json();

  if (body.success) {
    dispatch(signUpSuccess(body));
  } else {
    dispatch(signUpFailure(body));
  }

  return body;
};

export const loginStart = () => ({
  type: UserTypes.LOGIN_START
});

export const loginSuccess = payload => ({
  type: UserTypes.LOGIN_SUCCESS,
  payload
});

export const loginFailure = payload => ({
  type: UserTypes.LOGIN_FAILURE,
  payload
});

export const login = payload => async dispatch => {
  dispatch(loginStart());

  const response = await API.login(payload);
  const body = await response.json();

  if (body.success) {
    dispatch(loginSuccess(body));
    dispatch({
      type: UserTypes.AUTH_STORE_LOGIN_STATE
    });
  } else {
    dispatch(loginFailure(body));
  }

  return body;
};

export const logout = () => async dispatch => {
  dispatch({
    type: UserTypes.LOGOUT
  });
  dispatch({
    type: UserTypes.AUTH_CLEAR_STORED_LOGIN_STATE
  });
};



// WEBPACK FOOTER //
// ./src/actions/user.js